<script lang="ts">
    import { Button, Col, Image, Input, InputGroup, Row } from "sveltestrap";
    import { SEND } from "../../../../utils/Constant/Constant";
    import {selectList} from "../../../../store"
    import 'emoji-picker-element';
    import ChatHeader from "./ChatHeader.svelte";
    import ChatHistory from "./ChatHistory.svelte";
    let message:string
    let setMessage:string
    let time:any
    function hadleMessage() {
      time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: "2-digit" })
      setMessage = message
      message = ""
    }
    let setSelectList:any
    selectList.subscribe((value)=>{
      setSelectList = value
    })
    let open:boolean = false
    function handleEmoji(){
      open = !open
    }
</script>
<Col class="chat-right-aside">
  <div class="chat">
    <ChatHeader />
    <ChatHistory  setMessage={setMessage}/>
    <div class="chat-message clearfix">
      <Row>
        <Col xl="12" class="d-flex">
          <div class="smiley-box bg-primary">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class="picker" on:click={handleEmoji}>
              <Image src="/assets/images/smiley.png" alt="" />
            </div>
          </div>
          <InputGroup class="text-box">
            <Input class="input-txt-bx" id="message-to-send" type="text" name="message-to-send" bind:value={message} placeholder="Type a message......" />
            <Button color="primary" class="input-group-text" on:click={hadleMessage}>{SEND}</Button>
          </InputGroup>
        </Col>
      </Row>
    </div>
  </div>
</Col>
          